import React,{useRef,useState} from 'react'
import styled from 'styled-components'
import emailjs from '@emailjs/browser';
import { motion } from 'framer-motion';

const Contact = () => {
    const [name, setName] = useState('');
const [email, setEmail] = useState('');
const [message, setMessage] = useState('');
const [isEmailSent, setIsEmailSent] = useState(false);
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        setIsEmailSent(true);
         // Clear input fields
  setName('');
  setEmail('');
  setMessage('');

   // Remove the notification after 5 seconds
   setTimeout(() => {
    setIsEmailSent(false);
  }, 5000);
  
        emailjs.sendForm('service_ihk59ca', 'template_a34um9g', form.current, 'KGgbWqKfOtQLYUVrZ')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };
  return ( <Wrapper>
    <motion.div
      className="msg"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h2>
        I occasionally take on freelance opportunities.
      </h2>
      <p className="msgtext">
        I’m interested in freelance opportunities. However, if you have other requests or questions, don’t hesitate to
        contact me.
      </p>
    </motion.div>
    <motion.form
      ref={form}
      onSubmit={sendEmail}
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <input
        type="text"
        className="yourname"
        placeholder="Enter your name.."
        name="from_name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <input
        type="email"
        className="yourname youremail"
        placeholder="Enter your Email.."
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <input
        type="text"
        className="yourmsg"
        placeholder="Enter your Msg.."
        name="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
      />
      <div className="send">
        <input type="submit" value="SEND" />
      </div>
      {isEmailSent && (
        <motion.p
          className="notification"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          Email sent successfully!
        </motion.p>
      )}
    </motion.form>
  </Wrapper>
  )
}
const Wrapper = styled.div`

    width: 100%;
    height: 100vh;
    display: flex;
   justify-content: center;
   justify-items: center;
    align-items: center;
    flex-direction: column;
    gap: 25px;
    form{
        display: flex;
   justify-content: center;
   justify-items: center;
    align-items: center;
    flex-direction: column;
    gap: 15px;
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
 width: 100%;
 padding: 0 40px;
   
      }
    @media (max-width: 480px) {
                width: 100%;
                padding: 0 20px;
               }
               
    .send{

     width: 100%;
     height: 40px;
    text-decoration: none;
color:#121629 ;
background-color: #cbebf2;
font-size: 1.2rem;
   padding :6px 12px ;
   font-weight: 500;
   border-radius: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 5px;
   input{
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 1.5rem;
    background-color: transparent;
    border: none;
    font-weight: 500;
font-size: 1.2rem;
:hover{
    background-color: #121629;
    color: #cbebf2;
    border: 1px solid #cbebf2;
    padding: 5px 8px;
   border-radius: 10px;

   }
   }
   :hover{
    background-color: #121629;
    color: #cbebf2;
   }
   @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
    font-size: 2.5rem;
              height: 80px;
   
      }
   @media (max-width: 480px) {
              font-size: 1.6rem;
              height: 40px;
              width: fit-content;
               }
   img{
    width: 15px;
    height: 15px;
    transform: rotate(90deg);
    @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
    width: 30px;
    height: 30px;
   
      }
    
    @media (max-width: 480px) {
        width: 15px;
    height: 15px;
    transform: rotate(90deg);
               }
 
   }
    }
   
    .yourname{
        width: 600px;
        height: 40px;
        background-color: transparent;
        border: 2px solid  #ffffffb7;
        padding: 5px 15px;
        border-radius: 20px;
        font-size: 1rem;
        color: #ffffffb7;
        @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
width: 100%;
height: 60px;
font-size: 1.5rem;
   
      }
        @media (max-width: 480px) {
                width: 100%;
               }
    }
    .notification {
  background-color: #dff0d8;
  color: #3c763d;
  padding: 10px;
  margin-top: 10px;
  border-radius: 4px;
}
    .yourmsg{
        width: 600px;
        height: 100px;
        background-color: transparent;
        border: 2px solid  #ffffffb7;
        padding: 5px 15px;
        border-radius: 20px;
        color: #ffffffb7;
        font-size: 1rem;
        @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   height: 150px;
width: 100%;
font-size: 1.5rem;
   
      }
        @media (max-width: 480px) {
                width: 100%;
               }
    }
    }
    .msg{
        width: 75%;  
        display: flex;
        flex-direction: column;
   justify-content: center;
    align-items: center;
        text-align: center;
        gap: 25px;
        @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   padding: 0 30px;
width: 100%;
   
      }
        p{
            color: #dad6d6;
           width: 60%;
           font-size: 0.9rem;
           font-family: 'Fira Code', monospace;
           @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
 font-size: 1.8rem;
 width: 100%;
   
      }
           @media (max-width: 480px) {
                font-size: 1rem;
                width: 100%;
               }
        }
    }
    h2{
        color: #FB315A;
        font-size: 3.3rem;
        text-shadow: 2px 7px 5px #a41c5ba1, 
    0px -4px 10px #877e8349;
        font-family: 'Berkshire Swash', cursive;
        width: 60%;
       margin-right: 20px;
       letter-spacing: 1px;
       @media screen and (min-device-width: 768px)
and (max-device-width: 1024px) {
   
 font-size: 5rem;
 width: 100%;
   
      }
       @media (max-width: 480px) {
        margin: 0;
        width: 100%;
                font-size: 2.5rem;
               }
       
    }
`
export default Contact